import styles from "./ReferralHeroSectionDesktop.module.scss";
import CustomLink from "@Components/CustomLink";
import Image from "@Components/Image";
import Tooltip from "@Components/Tooltip/Tooltip";
import { BASE_IMG_URL } from "constants/configConstants";
import gtagEventEmitter from "helpers/gtagEventEmitter";
import { AppState } from "@Store/index";
import { useSelector } from "react-redux";
import { shareReferCodeChannel } from "constants/index";
import wrapperHOC from "@Utils/wrapperHOC";
import useCustomWindowOpen from "@Components/CustomWindowOpen";

interface SocialMediaBarDesktopProps {
  referrerLink: string | undefined;
}
const SocialMediaBarDesktop: React.FC<SocialMediaBarDesktopProps> = ({
  referrerLink = "https://amberstudent.com/places/leads/[refer-code]",
}) => {
  const { userData } = useSelector(({ appData }: AppState) => ({
    userData: appData.userData,
  }));
  const customWindowOpen = useCustomWindowOpen();
  // const shareBaseUrl = "https%3A%2F%2Famberstudent.com%2Fplaces%2Fleads%2F%5Brefer-code%5D";
  const handleShare = (url: any, label: any) => {
    gtagEventEmitter({
      action: "share_code_clicked",
      category: "",
      share_method: label,
      email_id: userData?.email,
    });

    // Replace the placeholder '[refer-code]' with the actual referrerLink
    const updatedUrl = url.replaceAll(
      "https%3A%2F%2Famberstudent.com%2Fl%2F[refer-code]",
      referrerLink,
    );
    customWindowOpen({ url: updatedUrl, target: "_blank", isExternal: true });
  };

  return (
    <div className={styles.socialMediaContainer}>
      <div className={styles.socials}>
        <CustomLink to="" target="_blank">
          <Tooltip
            content="Share on WhatsApp"
            direction="bottom"
            className={styles.tooltip}
            hideOnClick
            withTip
          >
            <span
              onClick={(e) => {
                e.preventDefault();
                handleShare(shareReferCodeChannel[0].redirect, shareReferCodeChannel[0].label);
              }}
              onKeyPress={() =>
                handleShare(shareReferCodeChannel[0].redirect, shareReferCodeChannel[0].label)
              }
              role="button"
              tabIndex={0}
            >
              <Image
                src={`${BASE_IMG_URL}/whatsapp-logo.svg`}
                alt="whatsapp-icon-image"
                height="24"
                width="24"
              />
            </span>
          </Tooltip>
        </CustomLink>
      </div>
      <div className={styles.socials}>
        <CustomLink to="" target="_blank">
          <Tooltip
            content="Share on Telegram"
            direction="bottom"
            className={styles.tooltip}
            hideOnClick
            withTip
          >
            <span
              onClick={(e) => {
                e.preventDefault();
                handleShare(shareReferCodeChannel[1].redirect, shareReferCodeChannel[1].label);
              }}
              onKeyPress={() =>
                handleShare(shareReferCodeChannel[1].redirect, shareReferCodeChannel[1].label)
              }
              role="button"
              tabIndex={0}
            >
              <Image
                src={`${BASE_IMG_URL}/telegram-logo.svg`}
                alt="telegram-icon-image"
                height="24"
                width="24"
              />
            </span>
          </Tooltip>
        </CustomLink>
      </div>
      <div className={styles.socials}>
        <CustomLink to="">
          <Tooltip
            content="Share via Email"
            direction="bottom"
            withTip
            className={styles.tooltip}
            hideOnClick
          >
            <span
              onClick={(e) => {
                e.preventDefault();
                handleShare(shareReferCodeChannel[2].redirect, shareReferCodeChannel[2].label);
              }}
              onKeyPress={() =>
                handleShare(shareReferCodeChannel[2].redirect, shareReferCodeChannel[2].label)
              }
              role="button"
              tabIndex={0}
            >
              <Image
                src={`${BASE_IMG_URL}/gmail-icon.png`}
                alt="email-icon-image"
                height="24"
                width="24"
              />
            </span>
          </Tooltip>
        </CustomLink>
      </div>
    </div>
  );
};

export default wrapperHOC(SocialMediaBarDesktop, {
  componentName: "SocialMediaBarDesktop-ReferralDesktop",
  showForChina: true,
});
